/**
 * Pure Monday-week arithmetic for Sprints (LG-999). No I/O, no clock of its
 * own -- every function takes `now`/dates as parameters.
 */
import { addUtcDays } from '../coaching/week-anchor.js'

const HOUR_MS = 3_600_000

export function addUtcHours(date: Date, hours: number): Date {
  return new Date(date.getTime() + hours * HOUR_MS)
}

/** The Monday 00:00 UTC on or before `date`. */
export function mondayOnOrBefore(date: Date): Date {
  // getUTCDay(): Sunday=0 .. Saturday=6, Monday=1. Days-since-Monday:
  // Monday->0, Tuesday->1, ..., Sunday->6.
  const daysSinceMonday = (date.getUTCDay() + 6) % 7
  return addUtcDays(date, -daysSinceMonday)
}

/**
 * Saturday 12:00 UTC before `startsAt` -- the single lock-in rule (spec:
 * "deliberately a one-function change"). `startsAt` is assumed to already be
 * a Monday 00:00 UTC; callers that materialize a Sprint own that invariant
 * (enforced in the DB by `Sprint_startsAt_monday_check`).
 */
export function lockInFor(startsAt: Date): Date {
  return addUtcHours(addUtcDays(startsAt, -2), 12)
}

export function isMondayMidnightUtc(date: Date): boolean {
  return (
    date.getUTCDay() === 1 &&
    date.getUTCHours() === 0 &&
    date.getUTCMinutes() === 0 &&
    date.getUTCSeconds() === 0 &&
    date.getUTCMilliseconds() === 0
  )
}
